var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSquiggleHorizontal = function SvgSquiggleHorizontal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 16 4"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,0H0S0,3.03,0,3.03c.52,.15,1.26,.29,2.19,.27,2.53-.06,4.21-.86,5.87-1.64C9.68,.9,11.27,.15,13.6,.13c.83,0,1.7,.09,2.4,.2V0Z"
  }))));
};
export default SvgSquiggleHorizontal;